import { chartQueryPeriods, matchChartPreset } from '@/data/charts/range';

export const CHART_FILTER_QUERY_KEYS = ['from', 'to', 'currency', 'book', 'preset'];

const CALENDAR_DAY = /^\d{4}-\d{2}-\d{2}$/;

const firstString = (value) => {
    if (value == null || value === '') {
        return '';
    }
    return String(Array.isArray(value) ? value[0] : value).trim();
};

export const pickChartFilterQuery = (query = {}) => {
    const picked = {};
    CHART_FILTER_QUERY_KEYS.forEach((key) => {
        const value = firstString(query[key]);
        if (value) {
            picked[key] = value;
        }
    });
    return picked;
};

export const sameChartFilterQuery = (left, right) => {
    const a = pickChartFilterQuery(left);
    const b = pickChartFilterQuery(right);
    return CHART_FILTER_QUERY_KEYS.every((key) => (a[key] || '') === (b[key] || ''));
};

export const mergeChartFilterQuery = (routeQuery, filterQuery) => {
    const next = {};
    Object.keys(routeQuery || {}).forEach((key) => {
        if (!CHART_FILTER_QUERY_KEYS.includes(key)) {
            next[key] = routeQuery[key];
        }
    });
    return { ...next, ...pickChartFilterQuery(filterQuery) };
};

const rangeFromCalendarDays = (from, to) => {
    if (!CALENDAR_DAY.test(from) || !CALENDAR_DAY.test(to) || from > to) {
        return null;
    }
    const [fromYear, fromMonth, fromDay] = from.split('-').map(Number);
    const [toYear, toMonth, toDay] = to.split('-').map(Number);
    const startDate = new Date(fromYear, fromMonth - 1, fromDay, 0, 0, 0, 0);
    const endDate = new Date(toYear, toMonth - 1, toDay, 23, 59, 59, 999);
    return { startDate, endDate };
};

export const chartFiltersFromQuery = (query, rangeOptions) => {
    const picked = pickChartFilterQuery(query);
    const currency = picked.currency === 'USD' ? 'USD' : 'MXN';
    const newBook = picked.book === 'new';
    const range = rangeFromCalendarDays(picked.from, picked.to);
    if (range) {
        const preset = picked.preset && picked.preset !== 'custom'
            ? picked.preset
            : matchChartPreset(range, rangeOptions);
        return { currency, preset, range, newBook };
    }
    return {
        currency,
        preset: picked.preset && picked.preset !== 'custom' ? picked.preset : 'mtd',
        range: null,
        newBook,
    };
};

export const chartFilterQueryFromState = ({
    currency,
    preset,
    newBook,
    range,
    rangeOptions,
    showNewBook,
}) => {
    const { current } = chartQueryPeriods(range, rangeOptions);
    const query = {
        from: current.from,
        to: current.to,
    };
    if (currency === 'USD') {
        query.currency = 'USD';
    }
    if (showNewBook && newBook) {
        query.book = 'new';
    }
    if (preset && preset !== 'mtd' && preset !== 'custom') {
        query.preset = preset;
    }
    return query;
};
